import Util from 'util/util'
import AvatarUtil from 'util/AvatarUtil'

export default class StudentModel extends Backbone.Model {

    preinitialize() {
        this.constructor.type = 'student'
        this.constructor.pluralType = 'students'
    }

    initialize() {
        AvatarUtil.generateAvatarIfMissing(this)
    }

    url() {
        return `/users/change_password_for_user/${this.get('id')}.json`;
    }

    last_name_first_name() {
        return Util.lastNameFirstName(this.get('first_name'), this.get('prefix'), this.get('sortable_last_name'))
    }

    first_name_last_name() {
        return Util.firstNameLastName(this.get('first_name'), this.get('prefix'), this.get('sortable_last_name'))
    }

    getLabel({displayFirstNameFirst = false} = {}) {
        const label = displayFirstNameFirst ? this.first_name_last_name() : this.last_name_first_name()
        return {
            label,
            title: label,
        }
    }

    getCrumblepathModel() {
        return new Backbone.Model({
            ...this.getLabel({displayFirstNameFirst: true}),
            level: 'students',
            path_id: this.get('id')
        });
    }

    getChildren() {}

    /**
     * getSiblings
     *
     * Get collection all students within the same group.
     *
     * @returns {StudentsCollection} student collection
     */
    getSiblings() {
        return this.collection;
    }

    /**
     * nextStudent
     *
     * Get next student in global collection or a particular group.
     *
     * @param {Number} groupId get the next student within a particular group
     * @returns {StudentModel} next student
     */
    nextStudent(groupId) {
        return (groupId ? Backbone.Collection.groups.get(groupId).students : this.collection).getNext(this);
    }

    /**
     * previousStudent
     *
     * Get previous student in global collection or a particular group.
     *
     * @param {Number} groupId get the previous student within a particular group
     * @returns {StudentModel} previous student
     */
    previousStudent(groupId) {
        return (groupId ? Backbone.Collection.groups.get(groupId).students : this.collection).getPrevious(this);
    }
}
